module.exports = __webpack_public_path__ + "static/media/rm_06-37.714ded77.png";